import { OwnerType } from '@/twapp/server/FileEndpoint';

angular.module("tromanWeb").controller('MeetingFilesController', ['meetingShared', function (meetingShared) {
    this.ownerId = meetingShared.meeting.Id;
    this.ownerType = OwnerType.Meeting;
}]);
